module.exports = __webpack_public_path__ + "img/moneysupermarket.38213b7d.png";